import React from 'react';
import { Root, createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ClayIconSpriteContext } from '@clayui/icon';
import { Provider } from 'react-redux';
import store from './store';
import './index.css';
import App from './App';

class WebComponent extends HTMLElement {
    private root: Root | undefined;

    connectedCallback() {
        if (!this.root) {
            this.root = createRoot(this);
            const queryClient = new QueryClient();
            this.root.render(
                <Provider store={store}>
                    <ClayIconSpriteContext.Provider
                        value={(window as any)?.Liferay?.Icons?.spritemap}
                    >
                        <QueryClientProvider client={queryClient}>
                            <App route={this.getAttribute('route')} />
                        </QueryClientProvider>
                    </ClayIconSpriteContext.Provider>
                </Provider>
            );
        }
    }
}

const ELEMENT_ID = 'business-expansion-form-custom-element';

if (!customElements.get(ELEMENT_ID)) {
    customElements.define(ELEMENT_ID, WebComponent);
}
